<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-10-14 08:40:59
 * @LastEditors: Jeson
 * @LastEditTime: 2021-10-14 10:24:57
-->
<template>
    <div>
        <div class="tag">
            满赠：
            <span>{{str}}</span>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ActiveTagNotice',
    props: {
        activityGiftList: {
            type: Array,
            default: () => []
        },
        ActivityId: {
            type: String,
            default: ''
        }
    },
    watch: {
        activityGiftList: {
            handler (val) {
                this.checkstr()
            },
            immediate: true,
            deep: true
        },
        ActivityId: {
            handler (val) {
                this.checkstr()
            },
            immediate: true,
            deep: true
        }
    },
    data () {
        return {
            str: ''
        };
    },
    // 生命周期
    created () { },
    mounted () {
    },
    unmounted () { },
    // 方法
    methods: {
        checkstr () {
            this.activityGiftList.map(oo => {
                if (oo.Id == this.ActivityId) {
                    let ActivityGiftList = oo.Configs[0].ActivityConfigPresent
                    let giftTypeMsg = ""
                    giftTypeMsg += oo.ConditionType == 1 ? '满' : oo.ConditionType == 2 ? '每满' : oo.ConditionType == 3 ? '买' : '每买'
                    giftTypeMsg += oo.Configs[0].Condition
                    giftTypeMsg += oo.Configs[0].ConditionValueType == 1 ? '元' : '盒';
                    giftTypeMsg += '将赠送' + this.getGiftContent(ActivityGiftList)
                    this.str = giftTypeMsg
                }
            })
        },
        getGiftContent (giftArr, buyMore) {
            let giftShowContent = ""
            for (let index = 0; index < giftArr.length; index++) {
                const item = giftArr[index];
                giftShowContent += `${item.Name ?? ""}${index < giftArr.length - 1 ? "、" : ""}`;

            }
            return giftShowContent;
        }
    }
}
</script>

<style lang="less" scoped>
.tag {
    width: 1200px;
    background: red;
    text-align: left;
    overflow: hidden;
    padding-left: 16px;
    font-size: 12px;
    color: white;
    height: 24px;
    line-height: 24px;
}
</style>